// src/stockx/base/SellingIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var SellingIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M44.06 41.65H5.83002V20.18H44.06V41.65ZM8.08002 39.4H41.81V22.43H8.08002V39.4Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M24.94 37.09C28.3476 37.09 31.11 34.3276 31.11 30.92C31.11 27.5124 28.3476 24.75 24.94 24.75C21.5324 24.75 18.77 27.5124 18.77 30.92C18.77 34.3276 21.5324 37.09 24.94 37.09Z",
      fill: colorized ? "#016341" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M39.91 14.26H9.98999V16.51H39.91V14.26Z",
      fill: colorized ? "#D5D2C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M36.87 8.34998H13.01V10.6H36.87V8.34998Z",
      fill: colorized ? "#D5D2C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M43.04 29.35C38.61 29.35 35 25.74 35 21.31H37.48C37.48 24.38 39.97 26.87 43.04 26.87V29.35Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M37.48 40.53H35C35 36.1 38.61 32.49 43.04 32.49V34.97C39.98 34.97 37.48 37.46 37.48 40.53Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.96002 29.35V26.87C10.03 26.87 12.52 24.38 12.52 21.31H15C15 25.74 11.39 29.35 6.96002 29.35Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15 40.53H12.52C12.52 37.46 10.02 34.97 6.96002 34.97V32.49C11.39 32.49 15 36.09 15 40.53Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var SellingIcon_default = SellingIcon;

export {
  SellingIcon_default
};
